import { render, staticRenderFns } from "./UserInvocations.vue?vue&type=template&id=0289854f&"
import script from "./UserInvocations.vue?vue&type=script&lang=js&"
export * from "./UserInvocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports